(function(){
  'use strict';

  const root = document.getElementsByTagName('html')[0];

  // Product grade button
  const pgBtn = document.querySelector('.js-modal-open-product-grade-modal');

  // Product grade modal
  const pgModal = document.querySelector('#ProductGradeModal');

  // Product grade close modal
  const closeModal = document.querySelectorAll('.js-modal-close, .icon-close');

  if (document.getElementsByClassName('product-block--grade').length) {
    pgBtn.addEventListener("click", function(e) {
      e.preventDefault();
      root.classList.add('modal-open', 'modal-open--solid');
      pgModal.classList.add('modal--is-active');
    });
  
    closeModal.forEach( function(close) {
      close.addEventListener('click', function(e) {
        e.preventDefault();
        root.classList.remove('modal-open', 'modal-open--solid');
        pgModal.classList.remove('modal--is-active');
      });
    });
  }
})();